import Rule from "./rule";
import FootballStats from "../football/stats/football-stats";
import Guard from "./utils/guard";
import FootballState from "../football/state/football-state";
import ValidationError from "../../services/exceptions/validation-error";

export default class StatsRule extends Rule {
    applicable(gameContext, ruleContext, eventConfiguration, { play }) {
        if (play.historyContains(FootballState.OnSide)) {
            const { collectStatsForOnSideKicks } =
                gameContext?.gameConfig?.general || {};

            return collectStatsForOnSideKicks;
        }

        return !play.historyContains(FootballState.NoPlay);
    }

    addStats(stats, allStats = []) {
        Guard.required(stats.gameId, "gameId");
        Guard.required(stats.playId, "playId");
        Guard.required(stats.fragmentId, "fragmentId");
        Guard.required(stats.category, "category");
        ///TODO: REMOVE
        this.validateStats(allStats, stats);
        //
        allStats.push(new FootballStats(stats));

        return allStats;
    }

    validateStats(allStats, stats) {
        const currentPlayIds = allStats.map((s) => s.playId);
        if (
            currentPlayIds?.length &&
            currentPlayIds.find((c) => c !== stats.playId)
        ) {
            console.log("Invalid stat play", stats, this.constructor.name);
            throw new ValidationError("Invalid Play Id");
        }
    }
}
